import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { AdminService } from '../../generated/auth/services/admin.service';
import * as ExternalNotificationActions from './external-notification.actions';
import { selectFilter, selectPagination } from './external-notification.selectors';

@Injectable()
export class ExternalNotificationEffects {
  private actions$ = inject(Actions);
  private adminService = inject(AdminService);
  private store = inject(Store);

  constructor() {}

  loadNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        ExternalNotificationActions.loadNotifications,
        ExternalNotificationActions.setFilter,
        ExternalNotificationActions.updatePagination,
      ),
      withLatestFrom(this.store.select(selectFilter), this.store.select(selectPagination)),
      switchMap(([action, filter, pagination]) => {
        let page = (action as any).filter?.Page || pagination.currentPage;

        const params = {
          ...filter,
          Page: page,
          PageSize: pagination.pageSize,
        };
        return this.adminService.adminManageGetNotificationsGet(params as any).pipe(
          map((response) => ExternalNotificationActions.loadNotificationsSuccess({ response })),
          catchError((error) => of(ExternalNotificationActions.loadNotificationsFailure({ error }))),
        );
      }),
    ),
  );
}
